import { render, staticRenderFns } from "./CheckInfo.vue?vue&type=template&id=50dec4f3&scoped=true&"
import script from "./CheckInfo.vue?vue&type=script&lang=ts&"
export * from "./CheckInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CheckInfo.vue?vue&type=style&index=0&id=50dec4f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dec4f3",
  null
  
)

export default component.exports